import React from 'react';
import { Attachments } from 'components';
import { useParams } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';

export const TaskAttachments = React.memo(() => {
  const { id } = useParams() as { id: string };
  const { hasAccess } = useAccessControl();
  return (
    <Attachments
      entityId={id}
      entityName={'TASK'}
      hasAccessToWrite={hasAccess(PERMISSIONS.tasks.attachment.write)}
      hasAccessToDelete={hasAccess(PERMISSIONS.tasks.attachment.delete)}
      service={'wrd'}
    />
  );
});
